import { render, staticRenderFns } from "./ProblemAnalysis.vue?vue&type=template&id=156f304e&scoped=true"
import script from "./ProblemAnalysis.vue?vue&type=script&lang=js"
export * from "./ProblemAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ProblemAnalysis.vue?vue&type=style&index=0&id=156f304e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f304e",
  null
  
)

export default component.exports